export default __webpack_public_path__ + "img/OrdpluTi.48962477.svg";